import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as FileSave from 'file-saver';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ProjectQuery } from 'src/app/projects/state/project.query';
import { SimulationQuery } from 'src/app/simulation/state/simulation.query';
import { FileDownload, FileDownloadStatus } from '../model/file-download.model';
import { ResultDownloadService } from '../service/result-download.service';

@Component({
  selector: 'app-result-download-list',
  templateUrl: './result-download-list.component.html',
  styleUrls: ['./result-download-list.component.scss']
})
export class ResultDownloadListComponent implements OnInit {

  isLoading: boolean;
  list$: Observable<FileDownload>;
  selected: FileDownload;
  Status = FileDownloadStatus;

  constructor(
    private resultDownloadService: ResultDownloadService,
    private projectQuery: ProjectQuery,
    private simulationQuery: SimulationQuery,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.isLoading = true;
    const projectId = this.projectQuery.getActiveId();
    const simulationId = this.simulationQuery.getActiveId();
    this.list$ = this.resultDownloadService.get(projectId, simulationId)
      .pipe(finalize(() => this.isLoading = false));
  }

  select(item: FileDownload) {
    if (item.status === FileDownloadStatus.PARAMS) {
      this.selected = item;
    } else if (item.status === FileDownloadStatus.DONE) {
      this.download(item.id);
    }
  }

  download(id: number) {
    this.isLoading = true;
    const projectId = this.projectQuery.getActiveId();
    const simulationId = this.simulationQuery.getActiveId();
    this.resultDownloadService.download(projectId, simulationId, id)
      .pipe(
        catchError(error => {
          this.snackBar.open($localize`Error on download result file`, $localize`CLOSE`, { duration: 2000 });
          return throwError(error);
        }),
        finalize(() => this.isLoading = false)
      )
      .subscribe(response => this.downloadFile(response));
  }

  private downloadFile(response: HttpResponse<Blob>) {
    FileSave.saveAs(response.body, this.getFileName(response));
  }

  private getFileName(response: HttpResponse<Blob>) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    return parts[1].split('=')[1];
  }
}
